<div class="w-full h-full flex items-center p-1 m-0 relative">
    @if(!value) {
        <i class="bx bx-search absolute left-3 text-gray-400 text-lg z-10 pointer-events-none"></i>
    }
    <app-select-input class="w-full table-dropdown-input" [ngClass]="{'pl-search': !value}" [options]="options" [placeholder]="placeholder" [ngModel]="value" (valueChange)="onValueChange($event)" [disabled]="disabled" [clearable]="clearable" [patch_first_value]="false" [appendTo]="'body'" [show_email]="show_email">
    </app-select-input>
</div>